<template>
	<div class="section-shaped my-0">
		<div class="shape shape-style-1 shape-skew">
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
		</div>
		<div style="height: 180px;"></div>
		<iframe class="airtable-embed airtable-dynamic-height" src="https://airtable.com/embed/shrmhv9DBt4gsabOW?backgroundColor=yellow" frameborder="0" onmousewheel="" width="100%" height="2045" style="background: transparent; border: 1px solid #ccc;"></iframe>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
	iframe {
		border: none !important;
	}
</style>
